import React, { Component } from 'react';
import { GraingerAccountContext } from '../../../Context/Context';

import PropTypes from 'prop-types';

import './Nav.scss';
import Pages from '../../../Context/Pages';

import Link from '../../Link/Link'

class Nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  getTab(name, screen) {
    return (
      <li className='nav-object'>
        <Link className='nav-link' page={screen}>{name}</Link>
      </li>
    );
  }

  render() {
    const { menuOpen } = this.props;

    return (
      <nav className={menuOpen && 'nav-expanded'}>
        <ul className='nav-list no-select'>
          {this.getTab('Home', Pages.Home)}
          {this.getTab('About Us', Pages.About)}
          {this.getTab('Our Team', Pages.Team)}
          {this.getTab('Services', Pages.Services)}
          {this.getTab('Contact Us', Pages.Contact)}
        </ul>
      </nav>
    );
  }
}

Nav.propTypes = {
  menuOpen: PropTypes.bool.isRequired,
};

Nav.contextType = GraingerAccountContext;
export default Nav;